/**
 * Reusable form validators for V3SYS frontend.
 * All error messages are in Polish.
 */

// === NIP: jedno zrodlo prawdy (CustomerModal, kasa POS) ===
// Suma kontrolna: wagi 6,5,7,2,3,4,5,6,7; suma mod 11 = ostatnia cyfra; reszta 10 = NIP bledny.
const NIP_WAGI = [6, 5, 7, 2, 3, 4, 5, 6, 7];
export const NIP_BLAD_DLUGOSC = 'NIP musi mieć 10 cyfr';
export const NIP_BLAD_SUMA = 'NIP jest błędny (zła suma kontrolna)';

/** Same cyfry NIP-u ('526-025-02-74' -> '5260250274'); pusty -> ''. */
export const normalizeNip = (value) => (value == null ? '' : String(value).replace(/\D/g, ''));

/** Czy tekst wyglada jak NIP (cyfry, spacje, kreski, opcjonalny prefiks PL). */
const nipTylkoCyfryISeparatory = (value) => /^(PL)?[\d\s-]*$/i.test(String(value ?? '').trim());

/** True tylko dla NIP-u poprawnego strukturalnie: 10 cyfr + zgodna suma kontrolna. */
export const isValidNip = (value) => {
  if (!nipTylkoCyfryISeparatory(value)) return false;
  const cyfry = normalizeNip(value);
  if (cyfry.length !== 10) return false;
  const suma = NIP_WAGI.reduce((acc, waga, i) => acc + waga * Number(cyfry[i]), 0);
  const reszta = suma % 11;
  return reszta !== 10 && reszta === Number(cyfry[9]);
};

/** Komunikat bledu NIP (null = poprawny; pusty NIP nie jest bledem - o wymagalnosci decyduje formularz). */
export const nipError = (value) => {
  if (value == null || String(value).trim() === '') return null;
  if (!nipTylkoCyfryISeparatory(value) || normalizeNip(value).length !== 10) return NIP_BLAD_DLUGOSC;
  return isValidNip(value) ? null : NIP_BLAD_SUMA;
};

export const validators = {
  required: (value, fieldName) =>
    !value?.toString().trim() ? `${fieldName} jest wymagane` : null,

  email: (value) =>
    value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? 'Nieprawidłowy email' : null,

  nip: (value) => nipError(value),

  phone: (value) =>
    value && !/^[\d\s+()-]{7,15}$/.test(value) ? 'Nieprawidłowy numer telefonu' : null,

  minLength: (value, min, fieldName) =>
    value && value.length < min ? `${fieldName} min. ${min} znaków` : null,

  maxLength: (value, max, fieldName) =>
    value && value.length > max ? `${fieldName} max. ${max} znaków` : null,

  positiveNumber: (value, fieldName) =>
    (isNaN(value) || Number(value) <= 0) ? `${fieldName} musi być liczbą > 0` : null,

  nonNegativeNumber: (value, fieldName) =>
    (isNaN(value) || Number(value) < 0) ? `${fieldName} nie może być ujemne` : null,

  ean: (value) =>
    value && !/^\d{8,13}$/.test(value) ? 'EAN musi mieć 8-13 cyfr' : null,

  price: (value) =>
    value && (isNaN(value) || Number(value) < 0) ? 'Nieprawidłowa cena' : null,
};

/**
 * Validate a data object against a set of rules.
 *
 * @param {Object} data  - form data object
 * @param {Object} rules - { fieldName: [ruleFn, ruleFn, ...], ... }
 *   Each rule function receives the field value and should return a string (error) or null.
 * @returns {Object|null} - { fieldName: errorMessage } or null when valid
 */
export function validateForm(data, rules) {
  const errors = {};
  for (const [field, fieldRules] of Object.entries(rules)) {
    for (const rule of fieldRules) {
      const error = rule(data[field]);
      if (error) {
        errors[field] = error;
        break;
      }
    }
  }
  return Object.keys(errors).length ? errors : null;
}
